import Icon from "@material-ui/icons/Category";

import Add from "./Add";
import Edit from "./Edit";
import List from "./List";

const Ads = { Icon, Add, Edit, List };

export default Ads;
